(function(){
  function reveal(){
    var els = document.querySelectorAll('.rv');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('show');});return;}
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('show'); io.unobserve(en.target);} });
    },{threshold:0.14});
    els.forEach(function(e){io.observe(e);});
  }
  if(document.readyState!=='loading'){reveal();}else{document.addEventListener('DOMContentLoaded',reveal);}

  // Navigable gallery viewer
  function initZoom(){
    var zoom=document.getElementById('zoom');
    if(!zoom) return;
    var track=document.getElementById('zoomTrack');
    var count=document.getElementById('zcount');
    function vertical(){ return window.matchMedia('(max-width:760px)').matches; }
    function open(srcs, idx){
      track.innerHTML = srcs.map(function(s){ return '<div class="zslide"><img class="art" src="'+s+'" alt=""></div>'; }).join('');
      zoom.hidden=false; document.body.style.overflow='hidden';
      var t=track.children[idx]; if(t) t.scrollIntoView({behavior:'auto',inline:'center',block:'center'});
      setCount(idx, srcs.length);
    }
    function setCount(i,len){ if(count) count.textContent = ('0'+(i+1)).slice(-2)+' / '+('0'+len).slice(-2); }
    function curIndex(){ var v=vertical(); var size=v?track.clientHeight:track.clientWidth; var pos=v?track.scrollTop:track.scrollLeft; return Math.round(pos/(size||1)); }
    function shut(){ zoom.hidden=true; document.body.style.overflow=''; track.innerHTML=''; }
    function goRel(d){ var i=Math.min(Math.max(curIndex()+d,0),track.children.length-1); var t=track.children[i]; if(t) t.scrollIntoView({behavior:'smooth',inline:'center',block:'center'}); }

    // Product gallery: photo + mockups, navigable together
    var pdpBtns = [].slice.call(document.querySelectorAll('.pdp-gallery .zoomable'));
    pdpBtns.forEach(function(btn){
      btn.addEventListener('click',function(){
        var srcs = pdpBtns.map(function(b){ return b.getAttribute('data-full'); });
        open(srcs, pdpBtns.indexOf(btn));
      });
    });
    // Series journal images (inside the article body), navigable together
    var artImgs = [].slice.call(document.querySelectorAll('.article-content img'));
    artImgs.forEach(function(img){
      img.style.cursor='zoom-in';
      img.addEventListener('click',function(){
        var srcs = artImgs.map(function(i){ return i.getAttribute('src'); });
        open(srcs, artImgs.indexOf(img));
      });
    });
    // Series mosaic images, navigable together
    var mosBtns = [].slice.call(document.querySelectorAll('.mosaic .zoomable'));
    mosBtns.forEach(function(btn){
      btn.addEventListener('click',function(){
        var srcs = mosBtns.map(function(b){ return b.getAttribute('data-full'); });
        open(srcs, mosBtns.indexOf(btn));
      });
    });
    // Any other single zoomable (e.g. article featured image)
    document.querySelectorAll('.zoomable').forEach(function(btn){
      if(btn.closest('.pdp-gallery') || btn.closest('.mosaic')) return;
      btn.addEventListener('click',function(){ open([btn.getAttribute('data-full')],0); });
    });

    var closeBtn=document.getElementById('zoomClose'); if(closeBtn) closeBtn.addEventListener('click',shut);
    var pv=document.getElementById('zprev'), nx=document.getElementById('znext');
    if(pv) pv.addEventListener('click',function(){ goRel(-1); });
    if(nx) nx.addEventListener('click',function(){ goRel(1); });
    var tk; track.addEventListener('scroll',function(){ clearTimeout(tk); tk=setTimeout(function(){ setCount(curIndex(),track.children.length); },60); },{passive:true});
    document.addEventListener('keydown',function(e){
      if(zoom.hidden) return;
      if(e.key==='Escape') shut();
      else if(e.key==='ArrowRight'||e.key==='ArrowDown'){ e.preventDefault(); goRel(1); }
      else if(e.key==='ArrowLeft'||e.key==='ArrowUp'){ e.preventDefault(); goRel(-1); }
    });
  }
  if(document.readyState!=='loading'){initZoom();}else{document.addEventListener('DOMContentLoaded',initZoom);}
})();

// Mobile hamburger menu
(function(){
  function initNav(){
    var btn=document.getElementById('navToggle');
    var panel=document.getElementById('mnav');
    var closeBtn=document.getElementById('navClose');
    if(!btn||!panel) return;
    function open(){ panel.hidden=false; btn.setAttribute('aria-expanded','true'); document.body.style.overflow='hidden'; }
    function close(){ panel.hidden=true; btn.setAttribute('aria-expanded','false'); document.body.style.overflow=''; }
    btn.addEventListener('click',function(){ panel.hidden ? open() : close(); });
    if(closeBtn) closeBtn.addEventListener('click',close);
    panel.addEventListener('click',function(e){ if(e.target===panel) close(); });
    panel.querySelectorAll('a').forEach(function(a){ a.addEventListener('click',close); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape' && !panel.hidden) close(); });
  }
  if(document.readyState!=='loading'){initNav();}else{document.addEventListener('DOMContentLoaded',initNav);}
})();

// Force muted inline autoplay for hero videos (mobile browsers block autoplay without this)
(function(){
  function playHeroVideos(){
    document.querySelectorAll('video.hero-media').forEach(function(v){
      v.muted = true; v.defaultMuted = true; v.playsInline = true;
      v.setAttribute('muted',''); v.setAttribute('playsinline',''); v.setAttribute('webkit-playsinline','');
      if(v.offsetParent === null) return; // skip the hidden variants (wrong breakpoint)
      var p = v.play();
      if(p && p.catch){ p.catch(function(){}); }
    });
  }
  if(document.readyState!=='loading'){ playHeroVideos(); }
  else { document.addEventListener('DOMContentLoaded', playHeroVideos); }
  window.addEventListener('orientationchange', function(){ setTimeout(playHeroVideos, 300); });
})();

// Hero video: strengthen mobile autoplay (hide iOS play button handled in CSS; start on first interaction as fallback)
(function(){
  function playAll(){
    document.querySelectorAll('video.hero-media').forEach(function(v){
      v.muted=true; v.defaultMuted=true; v.playsInline=true;
      v.setAttribute('muted',''); v.setAttribute('playsinline',''); v.setAttribute('webkit-playsinline','');
      v.removeAttribute('controls');
      if(v.offsetParent===null) return; // only the visible variant
      var p=v.play(); if(p&&p.catch) p.catch(function(){});
    });
  }
  function onFirst(){ playAll(); ['touchstart','scroll','click'].forEach(function(ev){ document.removeEventListener(ev,onFirst); }); }
  if(document.readyState!=='loading') playAll(); else document.addEventListener('DOMContentLoaded',playAll);
  ['touchstart','scroll','click'].forEach(function(ev){ document.addEventListener(ev,onFirst,{passive:true}); });
  window.addEventListener('orientationchange', function(){ setTimeout(playAll,300); });
})();
